'use client';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import EfEmarsysEmail from '../ef-emarsys-email';
import EfImg from '../ef-img';
import './index.scss';

interface fieldsType {
    id: string;
    type: string;
    value: number | number[];
    overwrite: boolean;
}

interface productType {
    value: string | number;
    label: string;
    checked?: boolean;
    fields: fieldsType[];
}

export interface EfEmarsysDialogBProps {
    /**
     * 是否打开弹窗
     */
    open: boolean;
    /**
     * contactListId
     */
    contactListId: string | string[];
    /**
     * fields 数组
     */
    fields?: fieldsType[];
    /**
     * 所有分辨率展示的视频链接
     */
    pc: string;
    /**
     * 视频链接-分辨率小于等于1024px
     */
    h5?: string;
    /**
     * 标题
     */
    title?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 内标题
     */
    title2?: string;
    /**
     * 订阅产品列表
     */
    productList?: productType[];
    /**
     * 回调
     */
    callback?: () => void;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 邮箱
     */
    email?: string;
    /**
     * isMulti 是否同时传入多个contactListId
     */
    isMulti?: boolean;
    /**
     * source 订阅来源
     */
    source?: string;
}

const ICON = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 40 40" fill="none">
        <rect width="40" height="40" rx="20" fill="#F4F4F4" />
        <path d="M27.5 27.5L12.5 12.5" stroke="#707070" strokeWidth="3.64072" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M27.5 12.5L12.5 27.5" stroke="#707070" strokeWidth="3.64072" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

/**
 * 用于播放视频
 *
 * 视频右上角会有个播放按钮,在不播放时展示
 */
export default function EfEmarsysDialogB({
    open,
    contactListId,
    fields,
    isMulti = false,
    source,
    pc,
    h5,
    title,
    desc,
    title2,
    productList = [],
    callback,
    className = '',
}: EfEmarsysDialogBProps) {
    const prefixCls = 'ef-emarsys-dialog-b';
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const dialogRef = useRef<any>(null);

    // 关闭
    const closeHandle = () => {
        dialogRef.current.close();
        callback && callback();
    };

    // 点击提交
    const submitHandle = (status: string) => {
        // gtm.push({
        //     event: 'uaEvent',
        //     event_name: 'activity_join',
        //     button_name: 'メルマガ登録',
        // });
    };

    useEffect(() => {
        if (open) {
            dialogRef.current.showModal();
        }
    }, [open]);

    return (
        <dialog className={compCls} ref={dialogRef}>
            <div className={`${prefixCls}-wrap`}>
                <div className={`${prefixCls}-content`}>
                    <div className={`${prefixCls}-close`} onClick={closeHandle}>
                        <ICON />
                    </div>
                    <div className={`${prefixCls}-body`}>
                        <div className={`${prefixCls}-msg`}>
                            {title && <div className={`${prefixCls}-title`}>{title}</div>}
                            {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
                        </div>
                        <div className={`${prefixCls}-box`}>
                            <div className={`${prefixCls}-info`}>
                                {title2 && <div className={`${prefixCls}-title2`}>{title2}</div>}
                                <EfEmarsysEmail
                                    contactListId={contactListId}
                                    fields={fields}
                                    productList={productList}
                                    isMulti={isMulti}
                                    source={source}
                                    className={`${prefixCls}-email`}
                                    needTerms={true}
                                    callback={submitHandle}
                                />
                            </div>
                            <div className={`${prefixCls}-img`}>
                                <EfImg pc={pc} h5={h5} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </dialog>
    );
}
